import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonRemoveSpread from '../../../components/Editor/ButtonRemoveSpread';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesController: { spreads: allSpreads },
			pagesSelection: { isActive, spreadIndices },
		},
	} = state;

	return {
		isDisabled: isActive && (spreadIndices.length === 0 || spreadIndices.length === allSpreads.length),
	};
};

export default connect(mapStateToProps)(ButtonRemoveSpread);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonRemoveSpread/index.tsx